import { render } from "./over-time.vue?vue&type=template&id=5f4a4f65"
import script from "./over-time.vue?vue&type=script&lang=js"
export * from "./over-time.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__